/* Standalone replacements for the offer's Funnelish interactions. */
(() => {
  const activate = (element, handler) => {
    element.tabIndex = 0;
    element.setAttribute('role', 'button');
    element.addEventListener('click', handler);
    element.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); handler(); }
    });
  };
  document.querySelectorAll('.faq').forEach((faq, index) => {
    const header = faq.querySelector('.faq-header');
    const content = faq.querySelector('.faq-content-wrapper');
    if (!header || !content) return;
    content.id = 'offer-faq-content-' + index;
    header.setAttribute('aria-controls', content.id);
    const sync = () => {
      const expanded = faq.classList.contains('active');
      header.setAttribute('aria-expanded', String(expanded));
      content.hidden = !expanded;
      content.style.height = expanded ? 'auto' : '0px';
    };
    activate(header, () => { faq.classList.toggle('active'); sync(); });
    sync();
  });
  document.querySelectorAll('.image-slider').forEach(slider => {
    const image = slider.querySelector('.is-image-wrapper img');
    const thumbs = [...slider.querySelectorAll('.is-thumbnail')];
    if (!image || !thumbs.length) return;
    let current = 0;
    const show = index => {
      current = (index + thumbs.length) % thumbs.length;
      image.removeAttribute('data-srcset');
      image.removeAttribute('srcset');
      image.removeAttribute('data-src');
      image.classList.remove('lazyload');
      image.src = thumbs[current].dataset.img.replace(/^\/\//, 'https://');
      image.alt = 'NeuroMD Corrective Therapy Device — image ' + (current + 1);
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('selected', i === current);
        thumb.setAttribute('aria-pressed', String(i === current));
      });
    };
    thumbs.forEach((thumb, i) => {
      thumb.setAttribute('aria-label', 'View product image ' + (i + 1));
      activate(thumb, () => show(i));
    });
    for (const [selector, offset, label] of [['.prev', -1, 'Previous product image'], ['.next', 1, 'Next product image']]) {
      const arrow = slider.querySelector(selector);
      if (arrow) { arrow.setAttribute('aria-label', label); activate(arrow, () => show(current + offset)); }
    }
    show(0);
  });
  document.querySelectorAll('[data-goto-element]').forEach(link => {
    link.setAttribute('href', link.dataset.gotoElement);
  });
  document.querySelectorAll('video[data-src]').forEach(video => { video.src = video.dataset.src; });
  const allowed = /^(utm_(source|medium|campaign|term|content|id)|gclid|fbclid|msclkid|ttclid)$/;
  document.querySelectorAll('a[href^="https://trial.getneuromd.com/"]').forEach(link => {
    const url = new URL(link.href);
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (allowed.test(key)) url.searchParams.set(key, value);
    }
    link.href = url.href;
  });
})();
